import React, { PropsWithChildren } from 'react';

export const HeaderNav = ({ children }: PropsWithChildren) => {
  return <nav className="header-nav">{children}</nav>;
};
